module.exports = __webpack_public_path__ + "img/icon-3.ef5e7503.svg";